import React from 'react'
import './../../assets/dateFilterRequest.css'
const DateFilterRequest = ({onFirstDateValueChange, onSecondDateValueChange ,onFilterValueChanged}) => {

  return (
    <>
      <div className="container-dates">
        <div className="row">
          <div className="col div-date" >
            <label htmlFor="date" className="col col-form-label label-filter">
              Inicial
            </label>
            <div className="col">
              <input
                type="date"
                className="form-control input-filters"
                id="initialDate"
                name="initialDate"
                onChange={onFirstDateValueChange}
              />
            </div>
          </div>
          <div className="col div-date" >
            <label htmlFor="date" className="col col-form-label label-filter">
              Final
            </label>
            <div className="col">
              <input
                type="date"
                className="form-control input-filters"
                id="finalDate"
                name="finalDate"
                onChange={onSecondDateValueChange}
              />
            </div>
          </div>
          <div className="col div-status">
            <label htmlFor="" className="col col-form-label label-filter">
              Estados
            </label>
            <div className="col">
              <select className="form-select input-filters" onChange={onFilterValueChanged}>
                <option value="">Todos</option>
                <option value="Created">Creado</option>
                <option value="OnApprovation">En aprobacion</option>
                <option value="Approved">Aprobado</option>
                <option value="Rejected">Rechazado</option>
                <option value="Completed">Completada</option>
                <option value="Canceled">Anulada</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DateFilterRequest